import { useListSupportedAppsQuery } from '../../../../__generated__/chirp/com/hubspot/unifiedaccount/rpc/AppRpc.hooks';
export const useUnifiedAccountSupportedApps = args => {
  var _args$skip;
  const {
    data,
    loading,
    error,
    networkStatus
  } = useListSupportedAppsQuery({
    skip: (_args$skip = args === null || args === void 0 ? void 0 : args.skip) !== null && _args$skip !== void 0 ? _args$skip : false
  });
  return {
    data: (data === null || data === void 0 ? void 0 : data.supportedApps) || [],
    loading,
    error: error || null,
    networkStatus
  };
};